import { useMutation } from 'react-query';
import { network } from 'services/network';
import { ICreateCardObjectReturn } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/helper';
import { QueryResponse as CardResponse } from 'api/queries/getMainCard.query';
import qs from 'qs';

const createEditCard = (params) => {
    return network
        .post('api/bo/createOrUpdateCard', params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const deleteCard = ({ cardId, versionId }: { cardId: number; versionId?: number }) => {
    const queryString = qs.stringify({ cardId, versionId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/removeCard${queryString}`;

    return network
        .get(url)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const useMutationCreateEditCard = () => {
    return useMutation<CardResponse, QueryError, ICreateCardObjectReturn>((params) => createEditCard(params));
};

export const useMutationDeleteCard = () => {
    return useMutation<string, QueryError, { cardId: number; versionId?: number }>(({ cardId, versionId }) =>
        deleteCard({ cardId, versionId }),
    );
};
